import type { FilterConfig } from '#types/config/components/filter'

export default {
  dialogOptions: { type: 'panel' }
} satisfies FilterConfig['pickup']
